/*
 * @Description: 项目模块
 * @Version: 1.0
 * @Autor: steFan
 * @Date: 2020-03-19 14:01:03
 * @LastEditors: steFan
 * @LastEditTime: 2020-03-19 18:45:19
 */
let dzr = {
    'banklist': '/pay/api/v1/memberBanks/list', //获取银行卡列表
    'addbank': '/pay/api/v1/memberBanks', //添加银行卡
    'mygame': '/game/api/v1/game/getPlayerRecentGame', //我的游戏
    'oneKeyBalance': '/game/api/v1/game/oneKeyBalanceCollection', //一键归集
    'getGameMoneyList': '/game/api/v1/game/getAllBalances', //获取游戏厂商列表
    'getuserMoney': '/game/api/v1/game/getAllBalances', //获取账户余额
    'querybank': '/pay/api/v1/banks/list', //查找银行
    'queryBalance': '/wallet/api/v1/money/queryBalance', //中心钱包余额，可提现
    'getCurrentAudit': '/pay/api/v1/audit/getCurrentAudit', //获取手续费，行政费用等
    'getlistPayWays': '/pay/api/v1/deposit/listPayWays', //获取充值方式
    'getPaymentNextStep': '/pay/api/v1/deposit/entranceDeposit', //充值入口
    'getBanklist': '/pay/api/v1/banks/list', //查找银行列表
    'entranceWithdraw': '/pay/api/v1/withdraw/entranceWithdraw', //提款
    'getRebateAmount': '/wallet/api/v1/rebates/getRebateAmount?memberId=', //查询反水
    'receiveRebate': '/wallet/api/v1/rebates/receiveRebate?memberId=', //领取反水
    'removeBack': '/pay/api/v1/memberBanks/', //删除银行卡
    'getThematicActivitiesListByApp': '/longm/api/v1/thematicActivities/getThematicActivitiesListByApp', //获取专题活动列表
    'getThematicActivitiesByApp': '/longm/api/v1/thematicActivities/getThematicActivitiesByApp', //app端专题活动详情
    'getListFloatingWindows': '/longm/api/v1/settingsEntryWindows/listFloatingWindows', // 获取浮悬框列表
    'signIn': '/longm/api/v1/thematicActivities/signIn', //点击签到
    'firstWithdraw': '/pay/api/v1/withdrawRecords/firstWithdraw', //验证是否首次
    'getClientMall': '/mall/api/v1/clientMall/getClientMall', //获取商城信息'
    getReceive: '/longm/api/v1/thematicActivities/receive?thematicActivitiesId=', //自助优惠领取
    getBindSmsSetting: '/longm/api/v1/settings/getBindSmsSetting', //银行卡添加短信验证
};

const api = {
    'captcha': '/member/api/v1/members/captcha',
    'login': '/member/api/v1/members/login',
    'banner': '/longm/api/v1/banners/app/list',
    'members': '/member/api/v1/members', //用户信息
    //-------------ptg--------------

    'menusList': '/longm/api/v1/menus/list', //获取游戏菜单
    'gamesDetail': '/game/api/v1/games', //获取游戏详情
    'getToken': '/game/api/v1/game/getToken', //获取游戏链接
    'hotGame': '/game/api/v1/game/hotGame', //热门游戏
    'recommendGame': '/game/api/v1/game/recommendGame', //推荐游戏
    'vendorGame': '/game/api/v1/manager/vendorGame', //获取三级
    'getGameByIds': '/game/api/v1/games/getGameByIds', //
    'getListCustomer': '/longm/api/v1/customers/app/getList', //获取客服地址
    'getPopUpAdsSetting': '/longm/api/v1/settings/getPopUpAdsSetting', //设置JP弹出啊条件
    'getGuideAd': '/longm/api/v1/guideAd/list', //获取多窗口广告弹窗
    'getGuideAd2': '/longm/api/v1/propaganda/list', //获取多窗口广告弹窗 专门为澳门金莎的接口处理
    //-------------ptg--------------
    // -----------------------------------------------------------------------------------------------------------------------xf-start
    'afterGameTransfer': '/game/api/v1/game/afterGameTransfer',
    'announcement': '/longm/api/v1/notices/app/home/list',
    'pcOnlinePayRecordsList': '/pay/api/v1/onlinePayRecords/pcOnlinePayRecordsList', //充值记录
    'bankTransfer': '/pay/api/v1/offlineRecords/pageLlist', //银行转账
    'withdrawalsRecords': '/pay/api/v1/withdrawRecords/appWithdrawRecordsList', //提款记录
    'rebates': '/wallet/api/v1/rebates/appList', //返水记录
    'logout': '/member/api/v1/members/logout', //退出登录
    'searchGame': '/game/api/v1/games/searchGame', //游戏搜索
    'balance': '/game/api/v1/game/getAllBalances', //用户余额查询
    'query': '/game/api/v1/game/queryBetRecords', //投注记录查询
    'platform': '/game/api/v1/vendorCallback/getAllVendorAndKindInfoByapp', //游戏平台列表get
    'clientCode': '/game/api/v1/background/platform/clientCode', //获取客服
    'codeList': '/longm/api/v1/appVersion/app/list', //获取二维码
    'getPartake': '/longm/api/v1/activities/getPartake', //活动记录
    'appActDetail': '/longm/api/v1/activities/appActDetail/', //活动记录详情
    'getJackpot': '/game/api/v1/game/getJackpot', //获取将次金额
    'getJackpotList': '/game/api/v1/game/getJackpotList', //超级赢家榜
    'appSave': '/agent/api/v1/agent/appSave', //获取将次金额
    'getContact': '/game/api/v1/background/platform/clientCode', //获取合作专区的联系方式
    'getCenterWallet': '/wallet/api/v1/money/getCenterWallet?memberId=', //冻结金额
    'getList': '/pay/api/v1/accountMoneyChange/getList', //其它
    'getAppList': '/wallet/api/v1/bonus/getAppList', //彩金列表
    'receive': '/wallet/api/v1/bonus/receive/', //领取彩金
    'getNotReceive': '/wallet/api/v1/bonus/getNotReceive', //彩金状态
    'getDigitRate': '/pay/api/v1/deposit/getDigitRate', //获取汇率
    'listDigitPayWays': '/pay/api/v1/deposit/listDigitPayWays', //绑定数字货币列表
    'memberRegister': '/longm/api/v1/settings/get/', //代理显示项
    'listQuickEntry': '/longm/api/v1/settingsEntryWindows/listQuickEntry', //头部动态设置选项及颜色等
    'getDefaultStatus': '/member/api/v1/validateCode/getDefaultStatus', //获取验证码类型
    'geetFirstRegister': '/member/api/v1/geeTest/firstRegister', //获取gt
    'availableAmount': '/wallet/api/v1/allowance/availableAmount', //会员可领取返利金额
    'validMemberCount': '/wallet/api/v1/allowance/validMemberCount', //有效会员
    'getReceive': '/wallet/api/v1/allowance/receive', //领取返利
    'referralLink': '/member/api/v1/members/referralLink', //获取返利邀请码及链接
    'allowanceExplain': '/wallet/api/v1/allowance/allowanceExplain', //高額返利規則
    'getSettings': '/longm/api/v1/settings/get/', //银行卡钱包数量
    'memberAllowanceCount': '/wallet/api/v1/allowance/memberAllowanceCount', //会员邀请人数
    'memberAllowanceRecord': '/wallet/api/v1/allowance/memberAllowanceRecord', //会员邀请查询
    'interestRecord': '/wallet/api/v1/interest/interestRecordList', //利息宝记录
    'interest': '/wallet/api/v1/interest/list', //利息宝列表
    'receiveInterest': '/wallet/api/v1/interest/receiveInterest/', //利息宝领取
    'interestDetail': '/wallet/api/v1/interest/interestDetail/', //利息宝详情
    'profitForecast': '/wallet/api/v1/interest/profitForecast', //利息宝计算利息
    'join': '/wallet/api/v1/interest/join', //利息宝立即存入
    'existRunningStatus': '/wallet/api/v1/interest/existRunningStatus', //利息宝new提示


    // -----------------------------------------------------------------------------------------------------------------------xf-end

    // ------------qq
    'register': '/member/api/v1/members/register', //注册
    'sendSmsCode': '/member/api/v1/members/mobile', //获取短信验证码
    'mobilebyacc': '/member/api/v1/members/mobilebyacc', // 通过账号获取验证码
    'updateInfo': '/member/api/v1/members/', //更新会员信息
    'bindPhone': '/member/api/v1/members/bindPhone', //绑定手机
    'updatePassword': '/member/api/v1/members/updatePassword', //修改登录密码
    'withdrawPassSet': '/member/api/v1/members/withdrawPass', //设置交易密码
    'withdrawPass': '/member/api/v1/members/withdrawPass', //修改交易密码
    'message': '/longm/api/v1/messages/list', //站内信列表
    'messageInfo': '/longm/api/v1/messages/get/', //站内信详情
    'readMessages': '/longm/api/v1/messages/read', //站内信标记已读
    'deleteMessage': '/longm/api/v1/messages/delete/', //删除站内信
    'deleteMessages': '/longm/api/v1/messages/delete', //批量删除站内信
    'noticeList': '/longm/api/v1/notices/app/home/list', //公告列表
    'noticeInfo': '/longm/api/v1/notices/app/', //公告详情
    'readNotice': '/longm/api/v1/notices/readNotices', //公告标记已读
    'activityType': '/longm/api/v1/settings/getSettingsByType/7', //获取优惠分类列表
    'activity': '/longm/api/v1/activities/list', //优惠活动列表
    'activityInfo': '/longm/api/v1/activities/appGet/', //活动详情
    'joinAct': '/longm/api/v1/activities/joinAct', //用户参与活动
    'autoJoinAct': '/longm/api/v1/activities/autoJoinAct', //用户自动参与活动
    'getTokenUrl': '/game/api/v1/game/getToken', //获取游戏链接
    'getvipdata': '/member/api/v1/memberLevels/', //获取会员等级信息
    'getVipList': '/member/api/v1/memberLevels/app/list', //获取会员列表，
    'getReturnWaterMoney': '/wallet/api/v1/rebates/getRebateAmount', //查询用户待领取返水金额
    'getRegisterSet': '/longm/api/v1/settings/get/', //获取注册设置
    'getRebateAmountDetail': '/wallet/api/v1/rebates/getRebateAmountDetail', //平台查询用户待领取返水金额明细
    'getDetailByBetNo': '/wallet/api/v1/rebates/getDetailByBetNo', //app返水记录查询批次信息
    'getMemberByName': '/member/api/v1/members/getMemberByName', //根据账号名称查询会员手机号
    'checkSmsCode': '/member/api/v1/members/checkSmsCode', //前台验证短信验证码
    'resetMemberPwdByClient': '/member/api/v1/members/resetMemberPwdByClient', //前台根据手机号重置用户密码
    'getAgentCommissionPlan': '/longm/api/v1/agentCommissionPlan/getAgentCommissionPlan', //获取佣金配置
    'validateLogin': '/member/api/v1/memberValidate/validateLogin', //登录异常验证
    'validateRealName': '/member/api/v1/memberValidate/validateRealName', //真实姓名校验
    'checkValidateSmsCode': '/member/api/v1/memberValidate/checkValidateSmsCode', //验证身份
    'sendValidateSmsCode': '/member/api/v1/memberValidate/sendValidateSmsCode', //发送验证码
    'deviceList':'/member/api/v1/members/memberDeviceFeatureCode/list/',//设备列表
    'deviceListDel':'/member/api/v1/members/memberDeviceFeatureCode/del/',//解绑设备
    // ------------qq
    ...dzr,
    'getReceive': '/wallet/api/v1/allowance/receive', //领取返利
};
module.exports = api;